import { TDateField } from '../../../../../types/sitecore.types';
import { CardModel } from '../../../../../models/card.model';
import { TNewsCardFields, TNewsCardProps } from '../types/newsCard.types';

export class NewsCardModel extends CardModel {
  protected readonly fields?: TNewsCardFields | null;

  constructor(props: TNewsCardProps) {
    super(props);
    this.fields = props.fields || null;
  }

  get date(): TDateField | undefined {
    return this.fields?.publishDate;
  }
}
